<ng-template #template>
  <div [class]="model.getActionRootCss()" [id]="id" #container>
    <div class="sv-action__content">
      <ng-container *ngIf="model.needSeparator">
        <div class="sv-action-bar-separator"></div>
      </ng-container>
      <ng-template [component]="{ name: model.component, data: { model }, default: 'sv-action-bar-item'}"></ng-template>
    </div>
  </div>
</ng-template>